import { render, staticRenderFns } from "./combobox-primary.vue?vue&type=template&id=d3856c54&scoped=true&"
import script from "./combobox-primary.vue?vue&type=script&lang=js&"
export * from "./combobox-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3856c54",
  null
  
)

export default component.exports